import { BranchMonthlyRevenueByState } from './branch-monthly-revenue-bystate';
import { customElement } from 'lit/decorators.js';
import { LangDashboardBranchMonthlyRevenue } from '../../../../localization/scripts/dealer-franchisee/dashboard/widget/branch-monthly-revenue-lang';
import { QuoteState } from '../../../api/dealer-api-interface-quote';
import { Snippet } from '../../../../webmodule-common/other/ui/events';

@customElement('dashboard-branch-monthly-revenue')
export class BranchMonthlyRevenue extends BranchMonthlyRevenueByState {
  protected async firstUpdated(): Promise<void> {
    this.state = QuoteState.Approved;
    await this.getData();
  }

  protected getHeader(): Snippet {
    return LangDashboardBranchMonthlyRevenue.monthlyGeneratedRevenue();
  }
}
